import React from 'react';
import './Recommendations.css';

const Recommendations: React.FC = () => {
  return (
    <div className='timeline-container'>
      <div className="recommendation-card">
        <div className="recommendation-header">
          <div style={{ fontSize: '3rem' }}></div>
          <div>
            <h3>Recommendations Coming Soon</h3>
            <p>Building my professional network</p>
          </div>
        </div>
        <div className="recommendation-body">
          <p> As I continue to grow in my career as a Full Stack Developer, I'm building meaningful professional relationships and working on exciting projects.</p>
          <p> Currently gaining valuable experience at <strong>Tabnet Security Pvt. Ltd.</strong> as a Software Developer Intern, developing mobile applications and data visualization dashboards.</p>
          <p> Previously contributed to <strong>Creatosaurus Pvt. Ltd.</strong> where I built web applications with AI-driven workflow optimization features.</p>
          <p> Open to new opportunities and collaborations!</p>
        </div>
      </div>
    </div>
  );
};

export default Recommendations;
